import type { VfConfig } from '#types/config/components/vf'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    rewardsPreviewTileButton: 'b b-grey-70 px-4 py-2',
  },
} satisfies RecursivePartial<VfConfig['loyalty']>
